import { useState, useEffect } from "react";
import WoodButton from "./WoodButton";
import Container from "./Container";
import RestMintProgress from "./RestMintProgress";
import LoadingModal from "./LoadingModal";
import OutcomeModal from "./OutcomeModal";
import EthereumInteraction from "./EthereumInteraction";
import { mint, claim, parseMint, isGenZeroClaim, isPublicMintEnabled } from "../utils/rest";
import { approve, getAllowance } from "../utils/erc20";
import { watchTransaction } from "../utils/ethereum";
import { decodeTokenURI } from "../utils/uri";
import { utils, BigNumber } from "ethers";
import classes from "../design/Minting.module.scss";

const PLACEHOLDER = "data:application/json;base64,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";

// TODO: keep MATIC mint price updated
const MINT_PRICE = "50";
const MIN_REQUIRED_ALLOWANCE = BigNumber.from("0x0aa87bee538000"); // 3,000,000 $FFWOOL

const RestMinting = ({ wallet, chain, stats, reload, woolBalance }) => {
    const [amount, setAmount] = useState(1);
    const [loading, setLoading] = useState(false);
    const [transacting, setTransacting] = useState(false);
    const [error, setError] = useState(null);
    const [outcomes, setOutcomes] = useState([]);
    const [, setMintingAndStaking] = useState(false);

    const [allowance, setAllowance] = useState(null);

    const [isClaimPeriod, setIsClaimPeriod] = useState();
    const [isMintEnabled, setIsMintEnabled] = useState();

    const [intervalMinting, setIntervalMinting] = useState();

    useEffect(async () => {
        if (wallet) {
            if (intervalMinting !== undefined) clearInterval(intervalMinting);

            const interval = setInterval(async () => {
                setIsClaimPeriod(await isGenZeroClaim());
                setIsMintEnabled(await isPublicMintEnabled());

            }, 2500);

            setIntervalMinting(interval);

            return () => clearInterval(interval);
        }
    }, [wallet]);

    useEffect(() => {
        if (isClaimPeriod === false) {
            if (wallet) {
                getAndSetAllowance(wallet);
            }
        }
    }, [wallet, isClaimPeriod]);

    const getAndSetAllowance = (walletAddress) => {
        getAllowance(process.env.REACT_APP_WOOL, walletAddress, process.env.REACT_APP_REST)
            .then(response => {
                setAllowance(response);
            })
            .catch(err => {
                console.error(err);
            });
    }

    const onApprove = async () => {
        setLoading(true);
        setError(null);
        try {
            let hash = (await approve(process.env.REACT_APP_WOOL, process.env.REACT_APP_REST)).hash;

            setTransacting(true);

            watchTransaction(hash, (receipt, success) => {
                if (!success) {
                    setLoading(false);
                    setTransacting(false);
                    return setError("Approve failed. Check transaction.");
                }

                setTimeout(async () => {
                    await presentApproval();
                    setLoading(false);
                    setTransacting(false);
                    getAndSetAllowance(wallet);
                }, 2000);
            });
        } catch (e) {
            console.log(e);
            setLoading(false);
        }
    };

    const onMint = async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await mint(amount, requiresEth());
            if (typeof result === "object" && !("hash" in result)) {
                setLoading(false);
                setTransacting(false);
                if (result?.data?.code === -32000) return setError("Mint failed. Insufficient funds.");
                else return setError("Mint failed.");
            }
            let hash = result.hash;

            setTransacting(true);
            setMintingAndStaking(false);

            watchTransaction(hash, (receipt, success) => {
                if (!success) {
                    setLoading(false);
                    setTransacting(false);
                    return setError("Mint failed. Check transaction.");
                }

                const results = parseMint(receipt);

                setTimeout(async () => {
                    await presentOutcomes(results);
                    setLoading(false);
                    setTransacting(false);
                }, 2000);
            });
        } catch (e) {
            console.log(e);
            setLoading(false);
        }
    };

    const onClaim = async () => {
        setLoading(true);
        setError(null);
        try {
            const result = await claim();
            if (typeof result === "object" && !("hash" in result)) {
                setLoading(false);
                setTransacting(false);
                return setError("You have no restaurants to claim.");
            }
            let hash = result.hash;

            setTransacting(true);
            setMintingAndStaking(false);

            watchTransaction(hash, (receipt, success) => {
                if (!success) {
                    setLoading(false);
                    setTransacting(false);
                    return setError("Mint failed. Check transaction.");
                }

                const results = parseMint(receipt);

                setTimeout(async () => {
                    await presentOutcomes(results);
                    setLoading(false);
                    setTransacting(false);
                }, 2000);
            });
        } catch (e) {
            console.log(e);
            setLoading(false);
        }
    };

    const presentOutcomes = async (results) => {
        const o = [];
        for (let i in results) {

            const { tokenId } = results[i];

            let u = PLACEHOLDER;

            o.push({
                message: `You are now the owner of Restaurant #${tokenId.toString()}`,
                source: decodeTokenURI(u).image,
                link: "",
                linkMessage: "",
            });

        }

        o.push({
            message: "To prevent exploits, your NFTs will be revealed after 10 more NFTs are minted (by anyone).",
            source: "",
            link: "",
            linkMessage: "",
        });

        setOutcomes(o);
    };

    const presentApproval = async () => {
        const o = [];
        o.push({
            message: "Successfully Approved Use of $FFWOOL",
            source: "/images/claimed-pack.gif",
            link: "",
            linkMessage: "",
        });
        setOutcomes(o);
    };

    const totalMinted = () => {
        return 3600;
        if (!stats) return 0;
        return parseInt(stats.restaurantTotalSupply);
    };

    const maxTokens = () => {
        if (!stats) return 3600;
        return stats.restaurantMaxTokens;
    };

    const requiresEth = () => {
        if (!stats) return false;
        return totalMinted() >= 3267;
    };

    const ethCost = () => {
        return utils.formatUnits(utils.parseUnits(MINT_PRICE, "gwei").mul(BigNumber.from(amount)), "gwei") + " MATIC";
    };

    const woolCost = (tokenId) => {
        if (!stats) return 0;
        if (tokenId <= 2467) return 300000;
        if (tokenId <= 2667) return 200000;
        if (tokenId <= 3267) return 100000;
        return 0;
    };

    const totalWoolCost = () => {
        if (!stats) return 0;
        let total = 0;
        let currentId = totalMinted();
        for (let i = 1; i <= amount; i++) {
            total += woolCost(currentId + i);
        }
        return total;
    };

    const preCheck = () => {
        if (requiresEth()) return undefined;
        if (isClaimPeriod === false && isMintEnabled) {
            if (!woolBalance || woolBalance === "?") return "Insufficient $FFWOOL";
            if (utils.parseUnits("" + totalWoolCost(), "gwei").gt(woolBalance)) return "Insufficient $FFWOOL";
        }
        return undefined;
    };

    return (
        <Container>
            <div className="text-xl sm:text-3xl font-bold mt-5 uppercase mb-5 text-center">Minting Restaurants</div>
            <div className="grid grid-cols-2 gap-2 items-center justify-around w-full">
                <div className="col-span-2 2xl:col-span-1 flex justify-center">
                    <RestMintProgress minted={totalMinted()} maxTokens={maxTokens()} />
                </div>
                {totalMinted() >= maxTokens() ? (
                    <div className="col-span-2 2xl:col-span-1 text-red text-xl sm:text-2xl text-center">Sold out!</div>
                ) : (
                    <EthereumInteraction wallet={wallet} chain={chain} className="col-span-2 2xl:col-span-1">
                        {isClaimPeriod ?
                            <div className={classes.mint}>
                                <p>Claim period is active</p>
                            </div>
                            :
                            isMintEnabled &&
                            <div className={classes.mint}>
                                <div className="flex justify-center items-center gap-2" style={{ height: "50px" }}>
                                    <div className="pt-2 mr-3">Amount:</div>
                                    <img
                                        src="/images/arrow-down.svg"
                                        alt="decrease"
                                        className="cursor-pointer"
                                        style={{ minWidth: "25px" }}
                                        onClick={() => {
                                            setAmount(Math.max(1, amount - 1));
                                        }}
                                    />
                                    <div className="font-console text-red text-xl sm:text-3xl pt-2"><span className={classes.amount}>{amount}</span></div>
                                    <img
                                        src="/images/arrow-up.svg"
                                        alt="increase"
                                        className="cursor-pointer"
                                        style={{ minWidth: "25px" }}
                                        onClick={() => {
                                            setAmount(Math.min(10, amount + 1));
                                        }}
                                    />
                                </div>
                                <div className="mb-5">
                                    Cost: <span className={classes.cost}><span className={classes.value}>{requiresEth() ? ethCost() : `${totalWoolCost()}`}</span> {requiresEth() ? "" : "$FFWOOL"}</span>
                                </div>
                            </div>
                        }

                        {preCheck() ?
                            <div className="text-red text-xl sm:text-2xl text-center">{preCheck()}</div>
                            :
                            <div className="flex xl:flex-row flex-col justify-center items-center gap-5">
                                <div className="flex flex-col justify-center items-center">
                                    {isClaimPeriod ?
                                        <WoodButton
                                            title={"CLAIM"}
                                            loading={loading}
                                            onClick={() => {
                                                onClaim();
                                            }}
                                        />
                                        :
                                        <>
                                            {isMintEnabled
                                                ?
                                                <>
                                                    {allowance && MIN_REQUIRED_ALLOWANCE.lte(allowance) ? (
                                                        <WoodButton
                                                            title={"MINT"}
                                                            loading={loading}
                                                            onClick={() => {
                                                                onMint();
                                                            }}
                                                        />
                                                    ) : (
                                                        <WoodButton
                                                            title={"APPROVE"}
                                                            loading={loading}
                                                            onClick={() => {
                                                                onApprove();
                                                            }}
                                                        />
                                                    )}
                                                </>
                                                : <div className="text-red text-xl sm:text-2xl">Minting Paused</div>
                                            }
                                        </>
                                    }
                                    <div className="mt-2" style={{ height: "20px" }}></div>
                                </div>
                            </div>
                        }
                        {error && <div className="text-xl text-red font-console text-center">{error}</div>}
                    </EthereumInteraction>
                )}
            </div>
            <LoadingModal
                loadingScenes={[
                    {
                        message: "Processing...",
                        source: "/images/minting.gif",
                    },
                ]}
                modalIsOpen={!!transacting}
            />
            <OutcomeModal
                outcomes={outcomes}
                modalIsOpen={outcomes.length > 0}
                closeModal={() => {
                    setOutcomes([]);
                    reload();
                }}
            />
        </Container>
    );
};

export default RestMinting;
